import AuthenticationService from "@soenergy/frontend-library/src/services/AuthenticationService"

export default ({ store }) => {
  AuthenticationService.init({
    store
  })
}
